module.exports = __webpack_public_path__ + "img/4.faae7e4f.png";